import React from 'react';
import "./TableItem.css";

const TableItem = ({time, text}) =>{
    return (
        <div className = "tableItem">
            <div className = "tableItemTime">
                <p>{time}</p>
            </div>
            {
                text
            }
        </div>
    )
}

export default TableItem;